module.exports = __webpack_public_path__ + "img/tomoon_icon.00159dad.png";